import Segment from '../models/Segment';
import Segments from '../collections/Segments';
import { baseApi } from 'core/api';

const state = () => ({
    _filterSegments: [],
});

const getters = {
    filterSegments: (state) => state._filterSegments,
};

const actions = {
    createOrganizationSegmentsCreate({ name, filters }) {
        return baseApi
            .post('core/organization/segments/create', {
                name: name,
                filters: {
                    filtersList: filters,
                },
            })
            .then((response) => {
                this._setFilterSegmentCreate(new Segment(response.data));

                return response.data;
            });
    },

    updateOrganizationSegmentsByIdUpdate({ id, name, filters }) {
        return baseApi
            .put(`core/organization/segments/${id}/update`, {
                name: name,
                filters: {
                    filtersList: filters,
                },
            })
            .then((response) => {
                this._setFilterSegmentUpdate(new Segment(response.data));

                return response.data;
            });
    },

    deleteOrganizationSegmentsByIdDelete(id) {
        return baseApi.delete(`core/organization/segments/${id}/delete`).then((response) => {
            this._setFilterSegmentDelete(id);

            return response.data;
        });
    },

    _setOrganization(organization) {
        this._filterSegments = new Segments(organization.organization_filters || []).models;
    },

    _setFilterSegmentCreate(filter) {
        this._filterSegments.push(filter);
    },

    _setFilterSegmentUpdate(filter) {
        this._filterSegments = this._filterSegments.map((item) => {
            if (item.id === filter.id) return filter;

            return item;
        });
    },

    _setFilterSegmentDelete(id) {
        this._filterSegments = this._filterSegments.filter((item) => item.id !== id);
    },
};

export default {
    state,
    getters,
    actions,
};
